<template>
  <div class="all-trans-record  default-wrap">
    <div class="wallet-tool-bar">
      <div class="filter" :class="{ fixed: listIsFixed }">
        <date-picker
          v-model="filter.period"
          :class="{ active: filter.period[0] && filter.period[1] }"
          placeholder="請選擇日期"
          format="YYYY.MM.DD"
          value-type="YYYY.MM.DD"
          rangeSeparator="-"
          range
        ></date-picker>
        <rent-select
          refName="withdraw"
          selectMsg="所有收入支出"
          @getId="getSelectId"
          border="1px solid #d5dad8"
          bgColor="#fff"
          :setDefault="isDefault"
        >
          <ul>
            <li :data-id="null">所有收入支出</li>
            <li data-id="DEPOSIT">收入</li>
            <li data-id="WITHDRAW">支出</li>
          </ul>
        </rent-select>
        <rent-select
          v-if="filter.withdraw"
          refName="item"
          selectMsg="所有項目"
          @getId="getSelectId"
          border="1px solid #d5dad8"
          bgColor="#fff"
          :setDefault="!filter.item"
        >
          <ul>
            <li data-id="">所有項目</li>
            <li v-for="(item, index) in transactionTypeList" :key="index" :data-id="item">{{transSource(item)}}</li>
          </ul>
        </rent-select>
      </div>
    </div>
    <div class="table-list withdraw">
      <div class="mask"></div>
      <div class="table-list-title">
        <span class="date">時間</span>
        <span class="income">收入/支出</span>
        <span class="item">項目</span>
        <span class="state">狀態</span>
        <span class="price">金額</span>
      </div>
      <div class="table-list-body">
        <!-- <div v-if="allRecordList.length != 0 && filterByContractDate.length == 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <button class="default-button" @click="setFilterDefault">清除篩選</button>
                </div> -->
        <div v-if="isLoading" class="filter-empty">
            <table-loading />
        </div>
        <div v-else-if="allRecordList.length == 0" class="is-empty">
          0 筆資料
        </div>
        <ul v-else>
          <li v-for="(item, index) in allRecordList" :key="index">
            <span class="date">{{ getFormatDate(item.createdDate) }}</span>
            <span class="income">{{
              transIncomeType(item.transactionType)
            }}</span>
            <span class="item">{{ transSource(item.depositOrigin) }}</span>
            <span class="state body blue" v-if="item.transactionType == 'DEPOSIT' && item.credited">可提領</span>
            <span class="state body gray" v-else-if="item.transactionType == 'DEPOSIT' && !item.credited">不可提領</span>
            <span class="state body" v-else></span>
            <span
              v-if="item.transactionType == 'DEPOSIT'"
              class="price"
              style="color:#3942b5"
              >+ {{ toCurrency(item.amount) }}</span
            >
            <span
              v-if="item.transactionType == 'WITHDRAW' || item.transactionType == 'TRANSFER_OUT'"
              class="price"
              style="color:#fc7171"
              >- {{ toCurrency(item.amount) }}</span
            >
          </li>
        </ul>
      </div>
  </div>
  </div>
</template>
<script>
import Modal from "@/components/widge/Modal.vue";
import RentSelect from "@/components/bussiness/widges/tools/RentSelect.vue";
import DatePicker from "vue2-datepicker";
import walletStoredInfo from "@/components/widge/modal/walletStoredInfo.vue";
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';

import { mapGetters } from "vuex";
import { 
    apiBizGetTransationType
    } from "@/apis/api.js"; 

export default {
  data() {
    return {
      componentKey: 0,
      isDefault: false,
      withdrawFilterState: null,
      withdrawModal: false,
      filterEmpty: false,
      listIsFixed: false,
      transactionTypeList: [],
      isLoading: true,
      filter: {
        period: ["", ""],
        item: "",
        withdraw: ""
      }
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$store.dispatch("getBizGetAllTransRecord", this.filter)
    .then(()=>{
      this.isLoading = false
    })
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    this.$store.dispatch("setBizAllRecordFilter", {
      // page: 1,
      period: ["", ""],
      item: "",
      withdraw: ""
    });
  },
  watch: {
    filter: {
      handler: function(val) {
        this.$store.dispatch("setBizAllRecordFilter", val).then(() => {
          this.$store.dispatch("getBizGetAllTransRecord");
        });
      },
      deep: true
    }
  },
  methods: {
    handleScroll(event) {
      let scrollTop = event.target.documentElement.scrollTop;
      // console.log(scrollTop)

      if (scrollTop >= 255) {
        this.listIsFixed = true;
        document.getElementsByClassName("parent-frame")[0].style.zIndex = "8";
      } else {
        document.getElementsByClassName("biz-tool-bar-wrap")[0].style.display =
          "flex";
        document.getElementsByClassName("parent-frame")[0].style.zIndex = "8";
        this.listIsFixed = false;
      }
    },
    getSelectId: function(value) {
      this.isDefault = false;

      if (value.ref == "withdraw") {
        this.filter.withdraw = value.id;
        this.getTransactionType(value.id)
        this.filter.item = ""
      } else if (value.ref == "item") {
        this.filter.item = value.id;
      }
    },
    setFilterDefault: function() {
      this.isDefault = true;
      this.period = [];
      this.withdrawFilterState = null;
    },
    getFormatDate: function(date) {
      var formatDate = [];
      var date = new Date(date);
      //一般日期 年 月 天 時 分
      formatDate[0] = date.getFullYear();
      formatDate[1] = date.getMonth() + 1;
      formatDate[2] = date.getDate();
      formatDate[3] = (Array(2).join(0) + date.getHours(-8)).slice(-2);
      formatDate[4] = (Array(2).join(0) + date.getMinutes()).slice(-2);
      formatDate[5] = (Array(2).join(0) + date.getSeconds()).slice(-2);
      //月及天兩位數
      formatDate[6] = (Array(2).join(0) + formatDate[1]).slice(-2);
      formatDate[7] = (Array(2).join(0) + formatDate[2]).slice(-2);

      return (
        formatDate[0] +
        "-" +
        formatDate[6] +
        "-" +
        formatDate[7] +
        " " +
        formatDate[3] +
        ":" +
        formatDate[4]
      );
    },
    transIdEncrypt: function(id) {
      return id.substr(0, 5) + "...";
    },
    getTransactionType: function (data) {
      apiBizGetTransationType(data)
      .then(res => {
          console.log(res)
          if( res.data.status == "SUCCESS" ){
              this.transactionTypeList = res.data.result
          }
      })
      .catch(err => {
      })
    }
  },
  computed: {
    ...mapGetters({
      allRecordList: "GET_BIZ_ALL_RECORD_LIST"
    })
  },
  components: {
    RentSelect,
    DatePicker,
    walletStoredInfo,
    Modal,
    tableLoading
  }
};
</script>
<style lang="scss">
.all-trans-record {
  padding: 0;
  margin-bottom: 200px;
  .wallet-tool-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px 24px;
    .filter.fixed {
      display: none;
      position: fixed;
      z-index: 50;
      margin-left: 785px;
      background: #fff;
      top: 0px;
      height: 80px;
      align-items: center;
    }
    .filter {
      display: flex;
      .biz-rent-select {
        width: 216px;
        margin-right: 10px;
      }
      .mx-datepicker {
        width: 216px;
        margin-right: 10px;
        input {
          width: 100%;
          height: 44px;
          border-radius: 4px;
          border: solid 1px #e0dfde;
          color: #a8a5a4;
          padding: 13px 16px;
          box-shadow: none;
          margin-bottom: 0px;
        }
        .mx-icon-calendar,
        .mx-icon-clear {
          right: 14px;
        }
      }
      .mx-datepicker:hover,
      .mx-datepicker.active {
        input {
          border: 1px solid #676362 !important;
          color: #676362 !important;
        }
        i {
          color: #676362;
        }
      }
    }
    .stored {
      display: flex;
      .money {
        position: relative;
        display: flex;
        align-items: center;
        margin-right: 16px;
        .sign {
          color: #292625;
          margin-right: 4px;
        }
        .number {
          color: #ff9275;
          margin-left: 6px;
          font-size: 28px;
        }
      }
      .default-button {
        width: 120px;
      }
    }
  }
  .withdraw {
    position: relative;
    width: 100%;
    border-radius: 0px;
    border: 0px;
    border-bottom: 1px solid #f0f0f0;
    border-top: 1px solid #f0f0f0;
    .table-list-title .date,
    .table-list-body ul li .date {
      width: 112px;
      margin-right: 180px;
    }
    .table-list-title .income,
    .table-list-body ul li .income {
      width: 80px;
      margin-right: 172px;
    }
    .table-list-title .item,
    .table-list-body ul li .item {
      width: 78px;
      margin-right: 143px;
    }
    .table-list-title .price,
    .table-list-body ul li .price {
      width: 204px;
      text-align: right;
    }
    .table-list-title .state,
    .table-list-body ul li .state{
        width: 76px;
        margin-right: 39px;
    }
    .table-list-body ul li .state.body{
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
    }
    .table-list-body ul li .state.blue{
        background-color: rgba(113, 170, 229, 0.1);
        color: #71aae5;
    }
    .table-list-body ul li .state.red{
        background-color: rgba(255, 146, 117, 0.1);
        color: #fc7171;
    }
    .table-list-body ul li .state.gray{
        background-color: #f3f3f3;
        color: #676362;
    }
  }
}
// @media screen and (max-width: 1280px) {
//   .all-trans-record {
//     .wallet-tool-bar {
//       .filter.fixed {
//         margin-left: 771px;
//       }
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/wallet/allTransRecord/allTransRecordComp.vue